import { security } from '@beelday/common'
import { useAuthenticatedBeeldayClient } from 'connectivity/beelday-hooks'
import { useCallback } from 'react'
import { leaveWorkflow } from 'room/common/model/room'
import { useJoinedRoomAddress } from 'room/common/use-joined-room-address'
import { useWorkflowUser } from 'room/common/use-workflow-user'
import { useJuno } from 'vcr/juno/juno-provider'
import { exitToSessionPlanning } from 'workflow/exit-to-session-planning'

/** Leaves the workflow and the conference, then goes back to session planning. */
export const useExitSession = (trainerId: string | undefined): (() => void) => {
	const joinedRoomAddress = useJoinedRoomAddress()
	const workflowUser = useWorkflowUser()
	// Before the user enters - on the join screen - there is no workflow user
	// yet, so who is leaving comes from the sign-in.
	const signedIn = security.useAuthenticatedUser()
	const beeldayClient = useAuthenticatedBeeldayClient()
	const juno = useJuno()
	return useCallback(() => {
		if (workflowUser && joinedRoomAddress) {
			leaveWorkflow(
				beeldayClient,
				joinedRoomAddress.workflowId,
				workflowUser.id
			)
			juno.juno?.leave()
		}
		exitToSessionPlanning({
			isTrainer: (workflowUser?.id ?? signedIn.id) === trainerId,
		})
	}, [
		beeldayClient,
		joinedRoomAddress,
		juno.juno,
		trainerId,
		workflowUser,
		signedIn.id,
	])
}

export default useExitSession
